<div class="confirmation">
  <div class="confirmation__titlebar">
    <ng-content select="[title]" />
  </div>
  <div class="confirmation__content">
    <ng-content select="[body]" />
  </div>
</div>
